import { useEffect } from "react";
import { motion, useMotionValue, useReducedMotion, useSpring } from "framer-motion";

/** Soft aurora glow that trails the pointer (pointer devices only). */
export default function CursorGlow() {
  const reduce = useReducedMotion();
  const x = useMotionValue(-500);
  const y = useMotionValue(-500);
  const sx = useSpring(x, { stiffness: 120, damping: 22, mass: 0.35 });
  const sy = useSpring(y, { stiffness: 120, damping: 22, mass: 0.35 });

  useEffect(() => {
    if (reduce) return undefined;
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    window.addEventListener("pointermove", move);
    return () => window.removeEventListener("pointermove", move);
  }, [reduce, x, y]);

  if (reduce) return null;

  return (
    <motion.div
      aria-hidden="true"
      style={{ x: sx, y: sy }}
      className="pointer-events-none fixed left-0 top-0 z-[5] hidden md:block"
    >
      <div className="h-[480px] w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-aurora-violet/[0.08] blur-[100px] mix-blend-screen" />
    </motion.div>
  );
}
